module.exports = __webpack_public_path__ + "img/2avatar.a53899de.png";